import React, { useState } from 'react';
import { RotateCw, Download, Loader2, ArrowLeft, File, RotateCcw } from 'lucide-react';
import { Link } from 'react-router-dom';
import { rotatePDF } from '../utils/pdfTools';

const RotatePdf = () => {
    const [file, setFile] = useState(null);
    const [rotation, setRotation] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type === 'application/pdf') {
            setFile(selectedFile);
            setRotation(0);
        }
    };

    const handleRotate = (direction) => {
        setRotation(prev => (prev + direction) % 360);
    };

    const handleSave = async () => {
        if (!file) return;

        setIsProcessing(true);
        try {
            const rotatedBlob = await rotatePDF(file, rotation);
            const url = URL.createObjectURL(rotatedBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `rotated_${file.name}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error rotating PDF:', error);
            alert('Failed to rotate PDF. Please try again.');
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="container animate-fade-in">
            <div style={{ marginBottom: '2rem' }}>
                <Link to="/tools/pdf" className="btn btn-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
                    <ArrowLeft size={16} /> Back to PDF Tools
                </Link>
            </div>

            <header className="flex-center" style={{ flexDirection: 'column', marginBottom: '3rem' }}>
                <div className="flex-center" style={{
                    width: '64px',
                    height: '64px',
                    background: 'linear-gradient(135deg, var(--primary), var(--primary-hover))',
                    borderRadius: '1rem',
                    marginBottom: '1rem',
                    color: 'white',
                    boxShadow: '0 10px 25px -5px rgba(99, 102, 241, 0.4)'
                }}>
                    <RotateCw size={32} />
                </div>
                <h1>Rotate PDF</h1>
                <p>Rotate your PDF pages permanently</p>
            </header>

            <main style={{ maxWidth: '800px', margin: '0 auto' }}>
                {!file ? (
                    <div className="glass-card" style={{ marginBottom: '2rem', textAlign: 'center', borderStyle: 'dashed', borderWidth: '2px' }}>
                        <input
                            type="file"
                            id="file-upload"
                            accept=".pdf"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="file-upload" className="btn btn-secondary" style={{ cursor: 'pointer' }}>
                            Select PDF File
                        </label>
                        <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>or drop file here</p>
                    </div>
                ) : (
                    <div className="glass-card" style={{ marginBottom: '2rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem', padding: '1rem', background: 'rgba(255,255,255,0.5)', borderRadius: '0.5rem' }}>
                            <div style={{ color: 'var(--primary)' }}><File size={32} /></div>
                            <div>
                                <h3 style={{ marginBottom: '0.25rem' }}>{file.name}</h3>
                                <p style={{ fontSize: '0.9rem' }}>{(file.size / 1024 / 1024).toFixed(2)} MB</p>
                            </div>
                            <button
                                onClick={() => { setFile(null); setRotation(0); }}
                                className="btn btn-secondary"
                                style={{ marginLeft: 'auto', padding: '0.5rem 1rem', fontSize: '0.9rem' }}
                            >
                                Change File
                            </button>
                        </div>

                        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                            <p style={{ marginBottom: '1rem', fontWeight: 600 }}>Current Rotation: {rotation}°</p>
                            <div className="flex-center" style={{ gap: '1rem' }}>
                                <button onClick={() => handleRotate(-90)} className="btn btn-secondary">
                                    <RotateCcw size={20} /> Left 90°
                                </button>
                                <button onClick={() => handleRotate(90)} className="btn btn-secondary">
                                    <RotateCw size={20} /> Right 90°
                                </button>
                            </div>
                        </div>

                        <div className="flex-center">
                            <button
                                className="btn btn-primary"
                                onClick={handleSave}
                                disabled={isProcessing}
                                style={{ padding: '1rem 2rem', fontSize: '1.1rem', width: '100%' }}
                            >
                                {isProcessing ? (
                                    <>
                                        <Loader2 className="animate-spin" /> Processing...
                                    </>
                                ) : (
                                    <>
                                        <Download /> Download Rotated PDF
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
};

export default RotatePdf;
